import React from 'react';
import PropTypes from 'prop-types';
import {Dialog, Box, Button, useMediaQuery} from '@mui/material';
import {makeStyles} from 'tss-react/mui';
import {agentDeveloperUtils} from 'wobi-web-common';
import breakpoints from 'wobi-web-common/dist/config/breakpoints';
import {Black} from 'wobi-web-common/dist/config/colors.config';
import {getImageByAgent} from '../config/agent';

const WhatsappLogo = getImageByAgent('whatsapp-logo.svg');

const useStyles = makeStyles()(theme => ({
  body: {
    color: theme.palette.secondary.dark,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.6,
    textAlign: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 20,
  },
  dismisBox: {
    position: 'relative',
    textAlign: 'start',
  },
  dismisButton: {
    '&:after': {
      transform: 'rotate(-45deg)',
    },
    '&:before': {
      transform: 'rotate(45deg)',
    },
    '&:before, &:after': {
      borderBottom: `2px solid ${Black[170]}`,
      content: '""',
      display: 'block',
      position: 'absolute',
      width: 20,
    },
    cursor: 'pointer',
    display: 'inline-block',
    height: 10,
    insetInlineStart: -5,
    position: 'relative',
    width: 20,
  },
  licenseNumber: {
    color: theme.palette.primary.main,
    direction: 'ltr',
    display: 'block',
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 700,
    marginBottom: 8,
    textAlign: 'center',
  },
  popover: {
    '& .MuiDialog-paper': {
      backgroundColor: `${theme.palette.background.default} !important`,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 12,
      maxWidth: 360,
      margin: 16,
    },
  },
  searchButton: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 25,
    color: theme.palette.primary.contrastText,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 700,
    padding: '10px 20px',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  title: {
    color: theme.palette.secondary.dark,
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 700,
    marginBottom: 4,
    textAlign: 'center',
  },
  whatsappButton: {
    backgroundColor: '#67D449',
    borderRadius: 25,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 700,
    padding: '10px 20px',
    '&:hover': {
      backgroundColor: '#5BC23E',
    },
    '& img': {
      marginLeft: 8,
      width: 24,
    },
  },
}));

const UnrecognizedVehiclePopup = ({open, anchorEl, onClose, licenseNumber, onSearchByModel, intl}) => {
  const {classes} = useStyles();
  const isMobile = useMediaQuery(`(max-width:${breakpoints.mobile}px)`);
  const whatsappNumber = agentDeveloperUtils.getWhatsappNumber;
  const messages = (id) => intl.formatMessage({id});

  const formattedLicense = licenseNumber
    ? `${licenseNumber.slice(0, 3)}-${licenseNumber.slice(3, 5)}-${licenseNumber.slice(5)}`
    : '';

  return (
    <Dialog
      open={open}
      className={classes.popover}
      onClose={onClose}
    >
      <Box sx={{p: 3}}>
        {isMobile && (
          <Box className={classes.dismisBox}>
            <span
              role='button'
              tabIndex={0}
              onClick={onClose}
              onKeyPress={onClose}
              className={classes.dismisButton}
            />
          </Box>
        )}
        <Box className={classes.title}>{messages('unrecognized_vehicle.title')}</Box>
        <Box className={classes.licenseNumber}>{formattedLicense}</Box>
        <Box className={classes.body}>
          {messages('unrecognized_vehicle.body')}
        </Box>
        <Box className={classes.buttons}>
          {whatsappNumber && (
            <Button
              className={classes.whatsappButton}
              href={`https://wa.me/${whatsappNumber}`}
              target='_blank'
              rel='noreferrer'
              fullWidth
            >
              {messages('unrecognized_vehicle.whatsapp_button')}
              <img src={WhatsappLogo} alt='whatsapp' />
            </Button>
          )}
          <Button
            className={classes.searchButton}
            onClick={onSearchByModel}
            fullWidth
          >
            {messages('unrecognized_vehicle.search_by_model_button')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

UnrecognizedVehiclePopup.propTypes = {
  anchorEl: PropTypes.any,
  intl: PropTypes.object.isRequired,
  licenseNumber: PropTypes.string,
  onClose: PropTypes.func,
  onSearchByModel: PropTypes.func,
  open: PropTypes.bool,
};

export default UnrecognizedVehiclePopup;
